import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import type { ManagedIntegration } from '../types';

type GetFusionIntegrationQueryKey = readonly ['fusion', 'details'];

export const useGetFusionIntegration: QueryFunction<
  ManagedIntegration | null,
  [],
  GetFusionIntegrationQueryKey
> = ({ requestOptions, queryOptions } = {}) => {
  const queryKey: GetFusionIntegrationQueryKey = ['fusion', 'details'];
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/integrations/fusion`, {
        init: {
          signal,
        },
      }),
  });
};
